/**
 * @generated SignedSource<<56e8fc9bfb592f66f54ad3f6267601ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodCreditCardCustomerRegisterStep_charge$data = {
  readonly id: string;
  readonly " $fragmentType": "PaymentMethodCreditCardCustomerRegisterStep_charge";
};
export type PaymentMethodCreditCardCustomerRegisterStep_charge$key = {
  readonly " $data"?: PaymentMethodCreditCardCustomerRegisterStep_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodCreditCardCustomerRegisterStep_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodCreditCardCustomerRegisterStep_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "e5d466742ce5f82e5be66af15c115bc4";

export default node;
